import Logo from '../assets/app/logo.png'
import { Toaster } from 'react-hot-toast';

const AuthLayout = ({ component: Component, ...props }) => {


    return (
        <div className="flex min-h-screen w-full items-center justify-center bg-nt-blue md:justify-end md:bg-auth md:bg-[length:50%] md:bg-left-bottom md:bg-no-repeat">
            <Toaster />
            <div className='mx-3 my-8 w-[92%] max-w-[520px] rounded-3xl border border-white/30 bg-white p-5 shadow-2xl backdrop-blur-sm md:mx-0 md:mr-[50px] md:my-0 md:p-8'>
                <div className='mb-4'>
                    <img src={Logo} alt='Ioparla' className='mx-auto mb-3 max-w-[165px]' />
                </div>
                <Component {...props} />
            </div>
        </div>
    );
};

export { AuthLayout };
